const { name } = __serviceInfo__;

export const akaLocalizationCookieName = 'aka_edgescape';
export const defaultMapsZoom = 14;
export const staticMapWidth = 375;
export const staticMapHeight = 190;
export const staticNearbyStoreMapWidth = 116;
export const staticNearbyStoreMapHeight = 116;
export const staticMapScale = 1;
export const ACTIVE = 'ACTIVE';
export const bopisDoorIdsCacheKey = 'bopisDoorIds';
export const bopisDoorsCachePeriodExpirationMinutes = 15;
export const sessionStorageKey = 'sessionStorage';
export const serviceName = name;
export const storeOpeningIsClosedTranslation = 'storeOpeningIsClosed';
export const timePlaceholder = '::time::';
export const defaultUIMode = 'LANDING';
export const amountPlaceholder = '::amount::';
export const mapMaxZoom = 16;
export const mapInfoWindowMaxHeight = 325;
export const mapBoxTabId = 'elc-map-box-tab';
export const mapListTabId = 'elc-list-box-tab';

export enum DeliveryOptions {
    STANDARD = 11,
    BOPIS = 101,
    COURIER = 102
}

export enum DeliveryMethods {
    STANDARD = 'HOME',
    BOPIS = 'BOPIS',
    COURIER = 'COURIER'
}

export enum EditDeliveryOptions {
    SHIP_TO_HOME = 'SHIP_TO_HOME',
    PICKUP_ALL_ITEMS = 'PICKUP_ALL_ITEMS',
    DROP_UNAVAILABLE = 'DROP_UNAVAILABLE'
}

export enum HomeDeliveryAvailability {
    AVAILABLE = 'Active',
    TEMPORARY_OUT_OF_STOCK = 'Temporarily out of stock',
    SOLD_OUT = 'Sold Out'
}

export enum StoreDeliveryOptions {
    DELIVERY_TYPE = 'delivery_type',
    STORE_SEARCH = 'store_search',
    CLICK = 'click',
    ZIPCODE_SEARCH = 'zipcode_search',
    CHANGE_STORE = 'change_store',
    STORE_SELECTION = 'store_selection',
    STORE_OPENING_HOURS_EXPAND = 'store_opening_hours_expand',
    STORE_OPENING_HOURS_COLLAPSE = 'store_opening_hours_collapse'
}

export const storesDirectoryPath = '/stores/store-directory';

export enum BooleanFilterTypes {
    OPEN_NOW = 'openNow',
    IN_STORE_PICKUP = 'inStorePickup',
    OAB_SERVICES = 'oabServices'
}

export const greedyGestureHandling = 'greedy';

export const bopisApiUrl = '/rest/api/v2/bopis/inventory';

export const deliveryMethodApi = '/rpc/jsonrpc.tmpl?dbgmethod=';

export const courierQuoteApi = '/rpc/jsonrpc.tmpl?dbgmethod=courier.get_quote';

export const transactionApi = '/rpc/jsonrpc.tmpl?dbgmethod=';
